<template>
  <div class="balance-block payout-balance-block">
    <div class="balance-block-wrapper">
      <img src="../../img/walletDark.svg" class="img" />
      <div class="desc big dark amount">
        <b>{{ roundedPayoutBalance }} </b>
        <img src="../../img/coin.svg" class="coin" />
      </div>
      <div class="button" @click="$emit('withdraw')">
        WITHDRAW
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProfilePayoutBalanceBlock",
  props: {
    payoutBalance: {
      type: [Number, String],
      default: 0,
    },
  },
  computed: {
    roundedPayoutBalance() {
      return Math.floor((Number(this.payoutBalance) || 0) * 100) / 100;
    },
  },
};
</script>
